import { render, staticRenderFns } from "./SolicitarConstanciaEstudioFast.vue?vue&type=template&id=08662877"
import script from "./SolicitarConstanciaEstudioFast.vue?vue&type=script&lang=js"
export * from "./SolicitarConstanciaEstudioFast.vue?vue&type=script&lang=js"
import style0 from "./SolicitarConstanciaEstudioFast.vue?vue&type=style&index=0&id=08662877&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VCol,VContainer,VRow})
